module.exports = __webpack_public_path__ + "c615e118edc9ab2b90be90a736273e49.png";